import { post } from "../../../services/request";

export const getDocuments = (data) => post('Document/GetDocumentFileMappingList', data);
